export enum UserRoleKeyEnum {
  BillingCollections = 'billing-collections',
  BillingLeadership = 'billing-leadership',
  BusinessAdmin = 'business-admin',
  ClaimsAdjuster = 'claims-adjuster',
  CustomerService = 'customer-service',
  CustomerServiceManager = 'customer-service-manager',
  HomeWarrantyRetentionAgent = 'home-warranty-retention-agent',
  HomeWarrantySalesCloser = 'home-warranty-sales-closer',
  HomeWarrantySalesSdr = 'home-warranty-sales-sdr',
  PaymentsManager = 'payments-manager',
  QualityAssurance = 'quality-assurance',
  ReadOnly = 'read-only',
  Resolutions = 'resolutions',
  RetentionAgent = 'retention-agent',
  RetentionManager = 'retention-manager',
  SalesAgentCloser = 'sales-agent-closer',
  SalesAgentSDR = 'sales-agent-sdr',
  SalesDirector = 'sales-director',
  SalesManager = 'sales-manager',
  SuperAdmin = 'super-admin',
}

export type TUserRoleKey = `${UserRoleKeyEnum}`;

// Admins use this list to correct contract and quote data after a rewrite, so it deliberately spans
// retention as well as sales, on both the vehicle and home warranty sides.
export const ASSIGNABLE_SALES_REP_ROLE_KEYS: readonly UserRoleKeyEnum[] = [
  UserRoleKeyEnum.HomeWarrantyRetentionAgent,
  UserRoleKeyEnum.HomeWarrantySalesCloser,
  UserRoleKeyEnum.RetentionAgent,
  UserRoleKeyEnum.RetentionManager,
  UserRoleKeyEnum.SalesAgentCloser,
  UserRoleKeyEnum.SalesManager,
];
